var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "shop-sticker-container",
      on: { click: _vm.reconnectConciergerie },
    },
    [
      _c(
        "Tooltip",
        {
          staticStyle: { width: "fit-content" },
          attrs: {
            active: _vm.disabled || !_vm.isConciergerie,
            text: !_vm.isConciergerie
              ? _vm.$t("dash.bots.status_proxy")
              : _vm.$t("dash.post.error.need_video.title"),
            position: "top",
          },
        },
        [
          _c(
            "vs-button",
            {
              staticClass: "shop-btn",
              attrs: {
                type: "border",
                color: "rgba(0, 0, 0, 0.2)",
                icon: "local_mall",
                disabled: _vm.disabled || !_vm.isConciergerie,
              },
              on: {
                click: () => {
                  _vm.tagUse ? _vm.$emit("click") : _vm.addShop()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.tagUse
                    ? _vm.$t("dash.post.btn.tag_shop")
                    : _vm.$t("dash.post.btn.add_shop")
                )
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: _vm.tagUse ? "searchTagImgShop" : "",
          style:
            _vm.tagUse &&
            "z-index: 10000000; position: fixed;" +
              (_vm.tagUse === "video" && "top: 50%; left: 50%;"),
        },
        [
          _vm.shopIsOpen
            ? _c(
                "div",
                {
                  staticClass: "auto-mentions row box",
                  style: _vm.tagUse && "z-index: 10000000;",
                },
                [
                  _c(
                    "div",
                    { staticClass: "search-box-shop" },
                    [
                      _vm.step !== "shop"
                        ? _c("vs-button", {
                            staticClass: "page-btn back-btn",
                            attrs: {
                              "vs-type": "filled",
                              color: "#6a1f4c",
                              icon: "arrow_back",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.backShop.apply(null, arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _c("vs-input", {
                        ref: "inputSearchShop",
                        staticClass: "inputx",
                        attrs: {
                          color: "#B20564",
                          type: "text",
                          name: "search-mention",
                          placeholder:
                            _vm.step === "shop"
                              ? "Rechercher un magasin"
                              : "Rechercher un produit",
                          autocomplete: "off",
                        },
                        on: {
                          keyup: () =>
                            _vm.step === "shop"
                              ? _vm.searchShop()
                              : _vm.searchProduct(),
                          click: () =>
                            _vm.step === "shop"
                              ? _vm.searchShop()
                              : _vm.searchProduct(),
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.searchedShop,
                          callback: function ($$v) {
                            _vm.searchedShop = $$v
                          },
                          expression: "searchedShop",
                        },
                      }),
                      _c(
                        "vs-button",
                        {
                          staticClass: "page-btn ok-btn",
                          attrs: { "vs-type": "filled", color: "#6a1f4c" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.insertShop.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("OK")]
                      ),
                    ],
                    1
                  ),
                  !_vm.tagUse
                    ? _c(
                        "p",
                        {
                          class: `product-count ${
                            _vm.selectedProducts.length === 5 && "full"
                          }`,
                        },
                        [_vm._v(_vm._s(_vm.selectedProducts.length) + "/5")]
                      )
                    : _vm._e(),
                  _vm.step === "shop"
                    ? _c(
                        "div",
                        {
                          staticClass: "vs-con-loading__container shops-list",
                          attrs: { id: "loading-shop" },
                        },
                        [
                          _vm.shopsList.length === 0
                            ? _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.no-result.title"))),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.shopsList, function (shop) {
                            return _c(
                              "div",
                              {
                                key: shop.id,
                                class: `shop-item ${
                                  _vm.selectedProducts
                                    .map((e) => e.id)
                                    .includes(shop.id) && "selected"
                                }`,
                                on: { click: () => _vm.selectShop(shop.id) },
                              },
                              [
                                _c("img", {
                                  attrs: { src: shop.image, alt: "logo" },
                                }),
                                _c("p", [_vm._v(_vm._s(shop.text))]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm.step === "items"
                    ? _c(
                        "div",
                        {
                          staticClass: "vs-con-loading__container items-list",
                          attrs: { id: "loading-items" },
                        },
                        [
                          _vm.itemsList.length === 0
                            ? _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.no-result.title"))),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.itemsList, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.id,
                                class: `items-item ${
                                  (_vm.selectedProducts
                                    .map((e) => e.id)
                                    .includes(item.id) ||
                                    _vm.selectedProducts
                                      .map((e) => e.product)
                                      .includes(item.id)) &&
                                  "selected"
                                }`,
                                on: {
                                  click: () =>
                                    item.variant
                                      ? _vm.colorsProduct(item.id)
                                      : _vm.selectProduct(item),
                                },
                              },
                              [
                                _c("img", {
                                  attrs: { src: item.image, alt: "logo" },
                                }),
                                _c("div", { staticClass: "items-infos" }, [
                                  _c("p", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item.text)),
                                  ]),
                                  _c("p", { staticClass: "description" }, [
                                    _vm._v(_vm._s(item.description)),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm.step === "colors"
                    ? _c(
                        "div",
                        {
                          staticClass: "vs-con-loading__container shops-list",
                          attrs: { id: "loading-color" },
                        },
                        _vm._l(_vm.colorsList, function (color) {
                          return _c(
                            "div",
                            {
                              key: color.id,
                              class: `shop-item ${
                                _vm.selectedProducts
                                  .map((e) => e.id)
                                  .includes(color.id) && "selected"
                              }`,
                              on: { click: () => _vm.selectProduct(color) },
                            },
                            [
                              _c("img", {
                                attrs: { src: color.image, alt: "logo" },
                              }),
                              _c("p", [_vm._v(_vm._s(color.number))]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }